module.exports = __webpack_public_path__ + "img/lock.56fde5db.svg";